export const formatMinutes = (minutes) => {
  if (!minutes || minutes === '0' || minutes === '00') {
    return '';
  }

  // Убираем ведущие нули, если они есть
  const cleanMinutes = minutes.replace(/^0+/, '');

  return `${cleanMinutes} мин.`;
};

export const convertMinutesToHoursMinutes = (totalMinutes) => {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return {
    hours: hours,
    minutes: minutes
  };
}